import { dayTransfer, monthTransfer } from "@/utils/dateTransfer.js";
import dayjs from "dayjs";
export default {
    login: {
      title: 'Renewable Energy',
      logIn: 'Login',
      username: 'Username',
      password: 'Password'
    },
    //消息提示
    message:{
      setLanguageSuccess:"Set language success"
    },
    common:{
      language: "language",
      resetPwd: 'Change password',
      exitMsg: 'Exit successfully!',
      day:'Day',
      month: 'Month',
      year: 'Year',
    },
    mainHome: {
      renewableEnergy: 'Renewable Energy',
      powerGeneration: 'Power Generation',
      powertoGrid: 'Power to Grid',
      cleanEnergyConsumption: 'Clean Energy Consumption',
      peakShavingCapacity: 'Peak Shaving Capacity',
      EVChargingCapacity: 'EV Charging Capacity',
      powerGeneration: 'Power Generation',
      totalPowerConsumption: 'Total Power Consumption',
      powerTransformerLoadRatio: 'Power Transformer: Load Ratio',
      substation: 'Substation',
      powerPlantMonthlyConsumption: 'Power Plant Monthly Consumption',
      carbonNeutral: 'Carbon Neutral',
      realTimeData: 'Real Time Data',
      energyConsumption: 'Energy Consumption',
      coalEquivalent: 'Coal Equivalent',
      CO2Emissions: 'CO₂ Emissions',
      dataTotal: 'Data Total',
      CO2Reduction: 'CO₂ Reduction',
      CO2ReductionRate: 'CO₂ Reduction Rate',
      powerGeneration: 'Power Generation',
      switchStation: 'SWITCH STATION',
      battery: 'BATTERY',
      evc: 'EVC',
      pv: 'PV',
    },
    osState: {
        standbyInitializes: 'standby:initializes',
        standbyInsulationImpedanceDetection: 'standby:Insulation impedance detection',
        standbyLightDetection: 'standby:Light detection',
        standbyGridDetection: 'standby:Grid detection',
        starting: 'Starting',
        gridConnectedRunning: 'Grid-connected(Grid-disconnected:Running)',
        gridConnectedLimitedPower: 'Grid-connected:limited power',
        gridConnectedSelfReducingRatedPower: 'Grid-connected:self-reducing rated power',
        shutdownAbnormal: 'Shutdown:Abnormal',
        shutdownCommand: 'Shutdown:Command',
        shutdownOVGR: 'Shutdown:OVGR',
        shutdownCommunicationBreak: 'Shutdown:Communication break',
        shutdownPowerLimited: 'Shutdown:Power Limited',
        shutdownMannualBoot: 'Shutdown:Mannual boot',
        shutdownDCSwitchC: 'Shutdown:DC switch c',
        shutdownQuickShutdown: 'Shutdown:Quick shutdown',
        shutdownInputUnderpower: 'Shutdown:Input underpower',
        powerGridDispatching: 'Power Grid Dispatching:cosϕ-P',
        powerGridDispatchingQU: 'Power Grid Dispatching:Q-U',
        powerGridDispatchingPFU: 'Power Grid Dispatching:PFU',
        powerGridDispatchingDryContact: 'Power Grid Dispatching:dry contact',
        powerGridDispatchingQP: 'Power Grid Dispatching:Q-P',
        spotReady: 'Spot Ready',
        spotChecking: 'Spot Checking',
        duringInspection: 'During inspection',
        AFCIChecking: 'AFCI Checking',
        IVScanning: 'IV scanning',
        DCInputChecking: 'DC Input Checking',
        runningChargingOffGrid: 'Running:Charging Off-grid',
        standbyNoLight: 'Standby:No light',
    },
    bwgManage: {
      dianliu : 'Cur.',
      dianya : 'Vol.',
      yougonggonglv: 'AP',
      wugonggonglv: 'RP',
      gonglvyinshu: 'pF',
      dayelec: dayTransfer[dayjs().format('DD') - 1],
      monthelec: monthTransfer[dayjs().format('MM') - 1],
      yearelec: dayjs().format('YYYY'),
      PVCS1: '1#PVCS',
      PVCS2: '2#PVCS',
      PVCS3: '3#PVCS',
      PVCS4: '4#PVCS',
      PVCS5: '5#PVCS',
      PVCS6: '6#PVCS',
      PVCS7: '7#PVCS',
      PVCS8: '8#PVCS',
      PVCS9: '9#PVCS',
      PVCS10: '10#PVCS',
      sharpPower: 'sharp power',
      peakPower: 'peak power',
      valleyPower: 'valley power'
    },
    nbqList: {
      anzhuangweizhi : 'Position',
      xinghao : 'Type',
      jiaoliugonglv: 'AC Pow.',
      shishi: 'RT POW.',
      dayelec: dayTransfer[dayjs().format('DD') - 1],
      runstate: 'Status',
    },
    bwgPowerManage: {
      bwg: 'PVCS',
      dianya: 'Vol.',
      dianliu: 'Cur.',
      yougonggonglv: 'AP',
      wugonggonglv: 'RP',
      gonglvyinshu: 'pF',
      elec_day: dayTransfer[dayjs().format('DD') - 1],
      elec_month: monthTransfer[dayjs().format('MM') - 1],
      elec_year: dayjs().format('YYYY'),
      shunshifenxi: 'Transient Trend Analysis',
      data: 'data',
      chart: 'graph',
      time: 'Time',
      daySelection: 'Day Selection',
      zhi: 'to',
    },
    photovoltaicPower: {
        nbq: 'Inverter',
        position: 'Position',
        elec_day: dayTransfer[dayjs().format('DD') - 1],
        model: 'Type',
        run_state: 'Status',
        jialiugonglv: 'AC Pow.',
        ri_elec: monthTransfer[dayjs().format('MM') - 1],
        shishi: 'RT Pow.',
        elec_total: 'Total G',
        shunshifenxi: 'Transient Trend Analysis',
        data: 'data',
        chart: 'graph',
        trend: 'Power Generation Trend Analysis',
        time: 'Time',
        daySelection: 'Day Selection',
        zhi: 'to',
        unit:'Unit',
        pcs_uab: 'Grid Uab',
        pcs_ubc: 'Grid Ubc',
        pcs_uca: 'Grid Uca',
        pcs_ia: 'Ia',
        pcs_ib: 'Ib',
        pcs_ic: 'Ic',
        pcs_lwpl: 'Off-grid Freq.',
        pcs_pl: 'On-grid Freq.',
        pcs_jlldl: 'AC Leak Cul',
        pcs_zldy: 'DV Vol',
        pcs_zldl: 'DC Cur',
        pcs_zzlgl: 'DC Pow',
        pcs_scszgl: 'Apparent Output',
        pcs_p: 'Active Pow',
        pcs_q: 'Reactive Pow',
        pcs_yxzt: 'PCS State',
        pcs_zcdl: 'Charging Energy',
        pcs_zfdl: 'Discharging Energy',
        pcs_rcdl: 'Daily Charging',
        pcs_rfdl: 'Daily Discharging',
        pcs_glys: 'PF',
        pcs_nbwd: 'Inner T',
        pcs_srqwd: 'Rediator T',
        bms_soc: 'SOC',
        bms_soh: 'SOH',
        bms_dccyxzt: 'Battery Cluster State',
        bms_zt: 'BMS State',
        bms_v: 'Vol.',
        bms_i: 'Cur.',
        bms_zgdtdy: 'Max. Cell Vol.',
        bms_zddtdy: 'Min. Cell Vol.',
        bms_zgwd: 'Max. Temp.',
        bms_zdwd: 'Min. Temp.',
        bms_zgsoc: 'Max Soc',
        bms_zdsoc: 'Min Soc',
        bms_zgdtdybh: 'Max. Cell Vol. No.',
        bms_zddtdybh: 'Min. Cell Vol. No.',
        bms_zgwdbh: 'Max. Temp. No.',
        bms_zdwdbh: 'Min. Temp. No.',
        bms_zdrxcddl: 'Max. Charging Cur.',
        bms_zdrxfddl: 'Max. Discharging Cur.',
        bms_cndtdygs: 'Number of Cell Vol.',
        bms_cndtwdgs: 'Number of Cell Temp.',
        bms_zddywd: 'Temp. of Max-Voltage Cell',
        bms_zxdywd: 'Temp. of Min-Voltage Cell',
        bms_zdwddy: 'Vol. of Max-T Cell',
        bms_zxwddy: 'Vol. of Min-T Cell',
        bms_cddlfz: 'Threshold Charging',
        bms_fddlfz: 'Threshold Discharging',
        collectTime: 'collect time'
    },
    networkDialog: {
      overview: 'Equipment Overview',
      photovoltaic: 'Photovoltaic',
      installedCapacity: 'Installed Capacity',
      PVInverter: 'PV Inverter',
      pcs: 'pcs',
      powerStorage: 'Power Storage',
      totalCapacity: 'Total Capacity',
      outputPower: 'Output Power',
      EVCharger: 'EV Charger',
      DCCharger: 'DC Charger',
      ACCharger: 'AC Charger',
      PVPowerGeneration: 'PV Power Generation',
      dailyGeneration: 'Daily Generation',
      monthlyGeneration: 'Monthly Generation',
      yearlyGeneration: 'Yearly Generation',
      frontDailyGeneration: 'Last Daily Generation', 
      frontMonthlyGeneration: 'Last Monthly Generation',
      frontYearlyGeneration: 'Last Yearly Generation',
      totalPowertoGridYTD: 'Total Power to Grid YTD',
      monthlyRecycleNumbers: 'Monthly Recycle Numbers',
      EVChargingCapacity: 'EV Charging Capacity',
      daily: 'Daily', 
      monthly: 'Monthly',
      yearly: 'Yearly',
      radiationComparison: 'Generation and Radiation Comparison',
      EVCOperationRevenue: 'EVC Operation Revenue',
      gffdl: 'Solar Generation',
      zfs: 'Radiation Quantity',
    },
    roofManage: {
      hj:'Environment Data',
      ssfengsu: 'Wind Speed',
      ssfengxiang: 'Wind Direction',
      sswendu: 'Temp',
      ssfuzhaodu: 'Irradiance',
      ljfuzhaodu: 'Radiant Quantity',
      ssshidu: 'Humidity',
      fuzhaoduquxian: 'Irandiance',
      fengsufengxiang: 'Rose Diagram',
      wenshiduquxian: 'Humiture',
      tai: 'Units',
      model: 'Type',
      jlgl: 'AC Pow',
      daypower: dayTransfer[dayjs().format('DD') - 1],
      monthpower: monthTransfer[dayjs().format('MM') - 1],
      yearpower: dayjs().format('YYYY'),
      ljpower: 'Total',
      sspower: 'Consumption Rate',
      run: 'Generation',
      factory2: '2# Factory',
      factory1_1: '1#-1 Factory',
      factory1_2: '1#-2 Factory',
      factoryHV: 'HV Factory',
      factoryIRP: 'IRP-1 Factory',
      factoryIRP_2: 'IRP-2 Factory',
      factoryLogistics: 'Logistics Factory',
      factoryMV: 'MV Factory',
      north: 'North',
      northeast: 'Northeast',
      east: 'East',
      southeast: 'Southeast',
      south: 'South',
      southwest: 'Southwest',
      west: 'West',
      northwest: 'Northwest',
    },
    windPowerGenerationMonitoring: {
      installedCapacity: 'Installed Capacity',
      pvCapacity: 'Pv Capacity',
      windPowerCapacity: 'Wind Power Capacity',
      dailyPowerGeneration: 'Daily Power Generation',
      dailyTCEReduction: 'Daily TCE Reduction',
      dailyCO2Reduction: 'Daily CO2 Reduction',
      monthlyPowerGeneration: 'Monthly Power Generation',
      monthlyTCEReduction: 'Monthly TCE Reduction',
      monthlyCO2Reduction: 'Monthly CO2 Reduction',
      annualPowerGeneration: 'Annual Power Generation',
      annualTCEReduction: 'Annual TCE Reduction',
      annualCO2Reduction: 'Annual CO2 Reduction',
      microgridRTPowerGeneration: 'Microgrid RT Power Generation',
      totalGeneratedElectricity: 'Total Generated Electricity',
      microgridTDComparison: 'Microgrid TD Comparison',
      fdfdl: 'wind power generation',
      fsfdl: 'peak time power generation',
      gsfdl: 'valley time power generation',
      psfdl: 'average time power generation',
      fdfdgl: 'wind power generation power',
      zrl: 'Total Capacity',
      gf: 'photovoltaic',
      fd: 'wind power',
      zjrl: 'installed capacity',
      fdl: 'generating electricity',
      daylyPower: 'Daily Power',
  },
    evcMonitoring: {
      top1 : 'EVC',
      top2 : 'Charging',
      top3: 'Discharge',
      top4: 'Offline',
      top5: 'Warning',
      title: 'EVC Monitoring',
      no: 'No.',
      online: 'Online',
      offline: 'Offline',
      fault: 'Fault',
      model: 'Socket Type',
      status: 'Status',
      price: 'Per kWh',
      shishi: 'RT Cur.',
      leiji: 'RT Pow.',
      money: 'Charge',
      yuan: '$',
      weichongdian: 'Standby',
      chongdianzhong: 'Charging',
      lixian: 'Offline',
      guzhang: 'Fault',
    },
    storageOverview: {
      dianzhanqingkuang : 'Overview',
      dianzhanqingkuang_1 : 'Capacity',
      dianzhanqingkuang_2: 'Rate Power',
      dianzhanqingkuang_3: 'Output Energy',
      dianzhanqingkuang_4: 'Module pc.',
      dianzhanqingkuang_5: 'RT Power',
      dianzhanqingkuang_6: 'Intput Energy',
      wan: '10k',
      chunengshouyi: 'Storage Revenues',
      danweiwanquan: 'USD',
      chongfangdian: 'Iutput/Output Energy',
      chongdianliang: 'Output',
      fangdianliang: 'Iutput',
      chunengxitong: 'Storage Overview',
      dianchiqingkuang: 'Battery',
      tanceqi_guzhang0: 'Work',
      tanceqi_guzhang1: 'Extinguisher Working',
      tanceqi_guzhang2: 'Sensor Fault',
      tanceqi_guzhang3: 'Hardware Fault',
      chuanganqi_tongxin_guzhang0: 'Work',
      chuanganqi_tongxin_guzhang1: 'Fault',
      day:'Day',
      month: 'Month',
      year: 'Year',
      kt_snhfwd: 'Return Air T',
      kt_snhfsd: 'Return Air Humidity',
      kt_hjwd: 'Condenser T',
      kt_zfwd: 'Evaporating T',
      kt_jssc: 'Humidifier Output',
      xf_tcqywdy: '1# Sensor-2# Temp',
      xf_tcqycond: '1# CO',
      xf_tcqyqtnd: 'Gas',
      xf_tcqyhqyjjb: '1# Sensor-Fire Monitoring',
      xf_tcqewdy: '2# Temp',
      xf_tcqecond: '2# CO',
      xf_tcqeqtnd: '2# GAS',
      xf_tcqehqyjjb: '2# Sensor-Fire Monitoring',
      xf_tcqywde: '1# Sensor-2# Temp',
      xf_tcqygzm: '1# Sensor-Fault Type',
      xf_tcqewde: '1# Sensor-2# Temp',
      xf_tcqegzm: '2# Sensor-Fault Type',
      cng_wd: 'Temp',
      cng_sd: 'Tumidness',
      cng_gz: 'Sensor COMM',
    },
    storageMonitor: {
      dianchicu: 'Battery Cluster',
      pcs_yxzt0: 'Stop',
      pcs_yxzt1: 'Standby',
      pcs_yxzt2: 'Fault',
      pcs_yxzt3: 'Charging',
      pcs_yxzt4: 'Discharging',
      pcs_yxzt5: 'Charging Reduction',
      pcs_yxzt6: 'Discharging Reduction',
      battery_run_state0: 'Stop',
      battery_run_state1: 'Charging',
      battery_run_state2: 'Discharging',
      battery_run_state3: 'Standby',
      battery_run_state4: 'Fault',
      bms_state1: 'work',
      bms_state2: 'warning',
      bms_state3: 'fault',
      bms_state4: 'protection',
      pcs_uab: 'Grid Uab',
      pcs_ubc: 'Grid Ubc',
      pcs_uca: 'Grid Uca',
      pcs_ia: 'Ia',
      pcs_ib: 'Ib',
      pcs_ic: 'Ic',
      pcs_lwpl: 'Off-grid Freq.',
      pcs_pl: 'On-grid Freq.',
      pcs_jlldl: 'AC Leak Cul',
      pcs_zldy: 'DV Vol',
      pcs_zldl: 'DC Cur',
      pcs_zzlgl: 'DC Pow',
      pcs_scszgl: 'Apparent Output',
      pcs_p: 'Active Pow',
      pcs_q: 'Reactive Pow',
      pcs_yxzt: 'PCS State',
      pcs_zcdl: 'Charging Energy',
      pcs_zfdl: 'Discharging Energy',
      pcs_rcdl: 'Daily Charging',
      pcs_rfdl: 'Daily Discharging',
      pcs_glys: 'PF',
      pcs_nbwd: 'Inner T',
      pcs_srqwd: 'Rediator T',
      bms_soc: 'SOC',
      bms_soh: 'SOH',
      bms_dccyxzt: 'Battery Cluster State',
      bms_zt: 'BMS State',
      bms_v: 'Vol.',
      bms_i: 'Cur.',
      bms_zgdtdy: 'Max. Cell Vol.',
      bms_zddtdy: 'Min. Cell Vol.',
      bms_zgwd: 'Max. Temp.',
      bms_zdwd: 'Min. Temp.',
      bms_zgsoc: 'Max Soc',
      bms_zdsoc: 'Min Soc',
      bms_zgdtdybh: 'Max. Cell Vol. No.',
      bms_zddtdybh: 'Min. Cell Vol. No.',
      bms_zgwdbh: 'Max. Temp. No.',
      bms_zdwdbh: 'Min. Temp. No.',
      bms_zdrxcddl: 'Max. Charging Cur.',
      bms_zdrxfddl: 'Max. Discharging Cur.',
      bms_cndtdygs: 'Number of Cell Vol.',
      bms_cndtwdgs: 'Number of Cell Temp.',
      bms_zddywd: 'Temp. of Max-Voltage Cell',
      bms_zxdywd: 'Temp. of Min-Voltage Cell',
      bms_zdwddy: 'Vol. of Max-T Cell',
      bms_zxwddy: 'Vol. of Min-T Cell',
      bms_cddlfz: 'Threshold Charging',
      bms_fddlfz: 'Threshold Discharging',
    }
  }
  